var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBoxing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.5C0.5 1.675 1.175 1 2 1H14C14.3978 1 14.7794 1.15804 15.0607 1.43934C15.342 1.72064 15.5 2.10218 15.5 2.5V4H0.5V2.5ZM1.25 5.2H14.75V13.4286C14.75 13.8264 14.592 14.2079 14.3107 14.4892C14.0294 14.7705 13.6478 14.9286 13.25 14.9286H2.75C2.35217 14.9286 1.97064 14.7705 1.68934 14.4892C1.40804 14.2079 1.25 13.8264 1.25 13.4286V5.2ZM5.75 6.5V8H10.25V6.5H5.75Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxing);
export default __webpack_public_path__ + "static/media/icon-boxing.59b9cb04813eda7b90287d4e9f92bda1.svg";
export { ForwardRef as ReactComponent };